/**
 * 此文件用于定义一些页面开发途中未开始对接接口时的测试数据
 */
import { ref } from 'vue'
import type { mediaType } from '~/server/newhouse/interface'

export function testData() {
  const pic = [
    'https://pic.3gbizhi.com/uploads/20240611/c7023e311e3d1a185f0386f327ac8a17.jpg',
    'https://pic.3gbizhi.com/uploadmark/20141013/02ef8013904980011206b3b7a0e547df.jpg',
    'https://pic.3gbizhi.com/uploads/20231017/1dcbcf53d6810cbec5e4d4e9f0cfaa6e.png',
  ]
  const picList = ref<mediaType[]>([
    {
      id: 1,
      title: '1',
      url: pic[0],
      cover: '1',
      panoramaId: 1,
      type: 1,
    },
    {
      id: 2,
      title: '2',
      url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      cover: pic[1],
      panoramaId: 2,
      type: 2,
    },
    {
      id: 3,
      title: '3',
      url: pic[2],
      cover: '3',
      panoramaId: 3,
      type: 1,
    },
  ])
  // 往picList中添加20条数据
  // for (let i = 0; i < 3; i++) {
  //   picList.value.push({
  //     id: i,
  //     title: '1',
  //     url: pic[i % 3],
  //     cover: '1',
  //     panoramaId: i,
  //     type: 1,
  //   })
  // }

  return {
    picList,
  }
}
